export class IssuePriority {
    name: string;
}